import { render, staticRenderFns } from "./ProcessamentoAvancado.vue?vue&type=template&id=66302441&scoped=true"
import script from "./ProcessamentoAvancado.vue?vue&type=script&lang=js"
export * from "./ProcessamentoAvancado.vue?vue&type=script&lang=js"
import style0 from "./ProcessamentoAvancado.vue?vue&type=style&index=0&id=66302441&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66302441",
  null
  
)

export default component.exports